var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ma-0 pa-0 iconContainer"},[_c('v-icon',{attrs:{"small":"","color":_vm.iconColor}},[_vm._v("fas fa-circle")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }